<template>

  <div id="simple-calendar-app">


    <div class="vx-card no-scroll-content">
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="holidays"
        enableDragDrop
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-date="openAddNewEvent"
        @click-event="openEditEvent"
        @drop-on-date="eventDragged">

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter">



            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
              </template>

            </div>
          </div>

          <div class="vx-row sm:flex hidden mt-4">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <div class="flex flex-wrap sm:justify-start justify-center">
                  <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                      <span>{{ label.text }}</span>
                  </div>
                  <!-- <div class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>
                      <span>None</span>
                  </div> -->
              </div>
            </div>
          </div>
        </div>
      </calendar-view>
    </div>

    <!-- ADD EVENT -->
    <vs-prompt
        class="calendar-event-dialog"
        title="Agendar Ferias"
        accept-text= "Agendar Ferias"
        @accept="addEvent"
        :is-valid="validForm"
        :active.sync="activePromptAddEvent">

        <div class="calendar__label-container flex">

            <vs-chip v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>

            <vs-dropdown vs-custom-content vs-trigger-click class="ml-auto my-2 cursor-pointer">

                <feather-icon icon="TagIcon" svgClasses="h-5 w-5" class="cursor-pointer" @click.prevent></feather-icon>

                <vs-dropdown-menu style="z-index: 200001">
                        <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                            <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                            <span>{{ label.text }}</span>
                        </vs-dropdown-item>

                        <vs-dropdown-item @click="labelLocal = 'none'">
                            <div class="h-3 w-3 mr-1 inline-block rounded-full mr-2 bg-primary"></div>
                            <span>None</span>
                        </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>

        </div>

        <vs-input name="event-name" v-validate="'required'" class="w-full" label-placeholder="Event Title" v-model="title"></vs-input>
        <div class="my-4">
            <small class="date-label">Start Date</small>
            <datepicker :language="$vs.rtl ? langHe : langEn" name="start-date" v-model="startDate" :disabled="disabledFrom"></datepicker>
        </div>
        <div class="my-4">
            <small class="date-label">End Date</small>
            <datepicker :language="$vs.rtl ? langHe : langEn" :disabledDates="disabledDatesTo" name="end-date" v-model="endDate"></datepicker>
        </div>
        <vs-input name="event-url" v-validate="'url'" class="w-full mt-6" label-placeholder="Event URL" v-model="url" :color="!errors.has('event-url') ? 'success' : 'danger'"></vs-input>

    </vs-prompt>

    <!-- EDIT EVENT -->
    <vs-popup
        class="calendar-event-dialog"
        title="Detalhes"
        v-model="popupShow"
        :active.sync="popupShow"
        accept-text= "Submit"
        cancel-text = "Remove"
        button-cancel = "border"
        @cancel="removeEvent"
        @accept="editEvent">


              <!-- Employee Information -->
                <div class="flex flex-wrap items-center flex-start mt-0">
                  <label class="text-sm font-bold">Funcionário:</label>
                  <span class="ml-2">{{ this.title }}</span>
                </div>

                <!-- <div class="flex flex-wrap items-center flex-start">
                  <label class="text-sm font-bold">Departamento:</label>
                  <span class="ml-2">{{ department }}</span>
                </div> -->

                <div class="flex flex-wrap items-center flex-start mt-1">
                  <label class="text-sm font-bold">Data de Início:</label>
                  <span class="ml-2">{{ formatDate(this.start_date) }}</span>
                </div>

                <div class="flex flex-wrap items-center flex-start mt-1">
                  <label class="text-sm font-bold">Data de Fim:</label>
                  <span class="ml-2">{{ formatDate(this.end_date) }}</span>

                </div>

                <div class="flex flex-wrap items-center flex-start mt-0">
                  <label class="text-sm font-bold">Status:</label>
                  <span class="ml-2">{{ this.getStatusName(this.status) }}</span>
                </div>

                <div class="flex flex-wrap items-center flex-start mt-5">
                  <!-- <label class="text-sm font-bold">Linha de Tempo de Aprovações</label> -->

                </div>






    </vs-popup>
  </div>
</template>

<style>
.table-container {
  max-width: 100%;
  overflow-x: auto;
}

.custom-table {
  border-collapse: collapse;
  border: 1px solid #ddd;
  width: 100%;
}

.custom-table thead th  {
  border: 1px solid #ddd;
  padding: 0px;
  font-size: 10px;
}

.grid-cell {
  border: 1px solid #ddd;
  text-align: center;
  padding: 8px;
}
</style>

<script>
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
import moduleCalendar from '@/store/calendar/moduleCalendar.js'
require("vue-simple-calendar/static/css/default.css")

import Datepicker from 'vuejs-datepicker'
import { en, he } from "vuejs-datepicker/src/locale"
import vSelect from "vue-select";
import http from "../../../../../http-common";
import http1 from "../../../../../http1-common";
import VxTimeline from "@/components/timeline/VxTimeline.vue"

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    vSelect,
    VxTimeline
  },
  data() {
    return {
      selectedMonth: {value : new Date().getMonth() + 1,  label: new Date(0,  new Date().getMonth()).toLocaleString('default', { month: 'long' })},
      selectedYear:  {value : new Date().getFullYear(), label : new Date().getFullYear()},
      vacations: [],
      filteredVacations:[],
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      status:'',
      start_date: '',
      end_date: '',
      showtitle: '',
      popupShow: false,
      labelLocal: 'none',
      departments:[],
      department:[{
        name:"",
        responsible_id:"",
      }],
      calendarLabels:[
        {
          color: "success",
          text :  "Aprovado",
          value  :  "Aprovado",
        },
        {
          color: "dark",
          text :  "Interropido",
          value  :  "Interropido",
        }
      ],
      months: [
        { value: 1, label: 'Janeiro' },
        { value: 2, label: 'Fevereiro' },
        { value: 3, label: 'Março' },
        { value: 4, label: 'Abril' },
        { value: 5, label: 'Maio' },
        { value: 6, label: 'Junho' },
        { value: 7, label: 'Julho' },
        { value: 8, label: 'Agosto' },
        { value: 9, label: 'Setembro' },
        { value: 10, label: 'Outubro' },
        { value: 11, label: 'Novembro' },
        { value: 12, label: 'Dezembro' }
      ],

      holidays: [ ],
      entry_date: '',
      exit_date: '',
      years: [],
      langHe: he,
      langEn: en,
      selectedDepartment:"",
      url: '',
      calendarView: 'month',

      activePromptAddEvent: false,
      activePromptEditEvent: false,

      calendarViewTypes: [
        {
          label: "Mês",
          val: "month"
        },
        {
          label: "Semana",
          val: "week"
        },
        {
          label: "Ano",
          val: "year"
        },
      ]
    }
  },
  mounted() {
   this.getDepartments();
   this.getVacations();


   const currentYear = new Date().getFullYear();
   const startYear = currentYear - 20;
   for (let year = currentYear; year >= startYear; year--) {
      this.years.push({ value: year, label: year.toString() });
    }

  },
  computed: {
    simpleCalendarEvents() {

        return this.$store.state.calendar.events

    },
    validForm() {
        return this.title != '' && this.startDate != '' && this.endDate != '' && (Date.parse(this.endDate) - Date.parse(this.startDate)) >= 0 && !this.errors.has('event-url');
    },
    disabledDatesTo() {
        return { to: new Date(this.startDate) }
    },
    disabledDatesFrom() {
        return { from: new Date(this.endDate) }
    },
    calendarLabels() {

        return this.calendarLabels;
    },
    labelColor() {
        return (label) => {
            if (label == "business") return "success"
            else if (label == "work") return "warning"
            if (label == "personal") return "danger"
            // if (label == "none") return "primary"
        }
    },

    windowWidth() {
      return this.$store.state.windowWidth
    },

    daysOfMonth() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const monthIndex = currentDate.getMonth();
      const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
      return Array.from({ length: daysInMonth }, (_, i) => i + 1);
    }
  },
  methods: {
    filterVacations() {



      this.filteredVacations = this.vacations.data.filter((item) => {
        const startDate = new Date(item.start_date);
        const startMonth = startDate.getFullYear();

        // Compare the start month with the selected month
        return startMonth === this.selectedYear.value;
      });

      console.log("Filtred ", this.filteredVacations )
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { day: "numeric", month: "long", year: "numeric" };
      return date.toLocaleDateString("pt-PT", options); // Adjust the locale as needed
    },

    isWithinRange(day, start_date, end_date) {
      const currentDay = new Date(start_date).getDate();
      const endDay = new Date(end_date).getDate();
      return day >= currentDay && day <= endDay;
    },

    getStatusName(status) {
      if (status === 'approved') {
        return 'Aprovado';
      } else if (status === 'pending') {
        return 'Pendente';
      } else if (status === 'rejected') {
        return 'Rejeitado';
      } else if (status === 'canceled') {
        return 'Cancelado';
      }

      else {
        return '';
      }
    },

    getStatusClass(status) {
        if (status === 'approved') {
          return 'event-success';
        } else if (status === 'pending') {
          return 'event-warining';
        } else if (status === 'rejected') {
          return 'event-danger';
        } else if (status === 'canceled') {
          return 'bg-dark';
        } else {
          return ''; // Default class when status is not recognized
        }
    },

    getVacations() {

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params: {
        }
      };

      http1
        .get("/vacations/employees", config)
        .then((result) => {
          this.vacations = result.data;

          this.filterVacations();

          console.log('Vacations ->' ,this.vacations);

          const mappedData = this.vacations.data.map((item) => {
            return {
              id: item.id,
              title: item.employee.user.name + ' ' + item.employee.user.surname, // Update this with the appropriate property from your server data
              startDate: new Date(item.start_date),
              endDate: new Date(item.end_date),
              status : item.status,
              label: item.type, // Update this with the appropriate property from your server data
              classes: this.getStatusClass(item.status), // Update this with the appropriate classes or dynamically assign based on other properties
              url: "", // Update this with the appropriate URL if needed
            };
        });


         this.holidays = mappedData;
         console.log('Mapped Data', mappedData)
        })
        .catch((error) => {

          console.log("error fecthing vactions", error)
        });
    },

    getDepartments() {


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/companies/departments", config)
        .then((result) => {
          this.departments = result.data.Departments.reverse();

        })
        .catch((error) => {
          error;

        });
    },
    addEvent() {
        const obj = { title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
        obj.classes = "event-" + this.labelColor(this.labelLocal)
        console.log(obj);
        this.$store.dispatch('calendar/addEvent', obj);
    },
    updateMonth(val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
    },
    clearFields() {
        this.title = this.endDate = this.url = "";
        this.id= 0;
        this.labelLocal = "none";
    },
    promptAddNewEvent(date) {
        // this.disabledFrom = false;
        // this.addNewEventDialog(date);

    },
    addNewEventDialog(date) {

        // this.clearFields();
        // this.startDate = date;
        // this.endDate = date;
        // this.activePromptAddEvent = true;
    },
    openAddNewEvent(date) {
        this.disabledFrom = true;
        this.addNewEventDialog(date);
    },
    openEditEvent(event) {

      const eventData = this.holidays.find(item => item.id === event.id);

      console.log("Event DATA ===>", eventData);

      this.showtitle = event.title;
      this.title = event.title;
      this.start_date = event.startDate;
      this.end_date = event.endDate;
      this.status = eventData.status;
      console.log(event);
      this.popupShow=true;



    },
    editEvent() {
      const obj = { id: this.id, title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
      obj.classes = "event-" + this.labelColor(this.labelLocal)
      this.$store.dispatch('calendar/editEvent', obj)
    },
    removeEvent() {
      this.$store.dispatch('calendar/removeEvent', this.id)
    },
    eventDragged(event, date) {
      this.$store.dispatch('calendar/eventDragged', {event: event, date: date})
    }
  },
  created() {
    this.$store.registerModule('calendar', moduleCalendar)
    this.$store.dispatch("calendar/fetchEvents")
    this.$store.dispatch("calendar/fetchEventLabels")
  },
  beforeDestroy() {
    this.$store.unregisterModule('calendar')
  },
  initialize(){
  this.getDepartments()
  // this.getCurrentUser()

  },




}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";

</style>
